import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/*Services*/
import { BaseHttpService } from '@services/http/base-http.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { AuthService, } from '@services/http/auth.service';

/*Environment */
import { environment } from '@environments';

/*Models*/
import { Service } from '@models';



@Injectable()
export class ServicesService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService
  ) {
    super(httpClient, cachedDataService, router, authService);
  }
  getServices(deviceId: string): Observable<Array<Service>> {
    const uri = environment.apiUri + 'simCardData/services';
    const params = new HttpParams()
        .set('deviceId', deviceId);

    return super.send('GET', uri, params);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/services.service.ts